export type EnvName = 'production' | 'fra1' | 'our1' | 'local' | 'onprem';

// TODO this declaration should probably move elsewhere (and get a more complete definition!)
// but this is good enough for now...
declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace NodeJS {
    interface ProcessEnv {
      ENV_NAME?: string;
      NODE_CONFIG_ENV: string;
      // Optional Webauthn config overrides
      WEBAUTHN_ORIGINS?: string;
      WEBAUTHN_RP_ID?: string;
      WEBAUTHN_RP_NAME?: string;
    }
  }
}

/**
 * Helper constant to prevent typos when comparing EnvNames.
 */
export const ENVIRONMENTS: Record<string, EnvName> = {
  production: 'production',
  fra1: 'fra1',
  our1: 'our1',
  onprem: 'onprem',
  local: 'local'
};

/**
 * Mapping of process.env.ENV_NAME to user-friendly EnvName string.
 */
const ENV_NAME_MAPPING: Record<string, EnvName> = {
  'US-SaaS': 'production',
  'EMEA-SaaS': 'fra1',
  OurPrem1: 'our1'
};

/**
 * Replacement for @kentik/lib/env getEnvName.
 */
export const getEnvName = (): EnvName =>
  // ENV_NAME is defined for all environments except local
  process.env.ENV_NAME == null ? 'local' : ENV_NAME_MAPPING[process.env.ENV_NAME] || 'onprem';
